//export * from '';
import { DynamicHotelListingEditable } from './RegionCardsWrapper';
import { DynamicHotelListingEditableProps } from './RegionCardsWrapper.types';
export { DynamicHotelListingEditable, DynamicHotelListingEditableProps };
